module.exports = __webpack_public_path__ + "static/infografico_cardiopatiacongenita-e1c994e13e3c734d69eeed7c24851d28.jpg";